import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import * as fromProfile from "../store/profile.reducers";
import * as ProfileAction from "../store/profile.actions";
import {Store} from "@ngrx/store";
import * as fromApp from "../../store/app.reducers";
import {ActivatedRoute, Params, Router} from "@angular/router";

@Component({
    selector: 'app-profile-waiting',
    templateUrl: './profile-waiting.component.html',
    styleUrls: ['./profile-waiting.component.scss'],
    standalone: false
})
export class ProfileWaitingComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  id: number;
  code: string;
  timeout: number;
  infoVisibility = 1;
  constructor(
      private store: Store<fromApp.AppState>,
      private route: ActivatedRoute,
      private router: Router
  ) { }

  ngOnInit() {
    this.store.dispatch(
        new ProfileAction.ClearCharts()
    );
    this.routeSubscription = this.route.params.subscribe(
        (params: Params) => {
          this.id = params.id;
          this.code = params.code;
          this.store.dispatch(
              new ProfileAction.GetProfileDetail({id: this.id, params: {code: this.code}})
          );
          this.store.dispatch(
              new ProfileAction.GetAudit({id: this.id, params: {code: this.code}})
          );
          this.store.dispatch(
              new ProfileAction.GetFollowerEngage({
                id: this.id,
                type: 1,
                params: {code: this.code}
              })
          );
          this.profileSubscription = this.store.select('profile').subscribe(
              (profile: fromProfile.State) => {
                if (profile.profileDetail === null) {
                  // clearTimeout(this.timeout);
                  this.timeout = setTimeout(() => {
                    this.store.dispatch(
                        new ProfileAction.GetProfileDetail({id: this.id, params: {code: this.code}})
                    );
                      this.store.dispatch(
                          new ProfileAction.GetAudit({id: this.id, params: {code: this.code}})
                      );
                      this.store.dispatch(
                          new ProfileAction.GetFollowerEngage({
                            id: this.id,
                            type: 1,
                            params: {code: this.code}
                          })
                      );
                  }, 30000);
                } else {
                    if (profile.audit !== null && profile.followerEngage !== null) {
                        if (profile.audit.status === 0) {
                            if (profile.followerEngage.post_count === 0) {
                                clearTimeout(this.timeout);
                                this.timeout = setTimeout(() => {
                                    this.store.dispatch(
                                        new ProfileAction.GetFollowerEngage({
                                          id: this.id,
                                          type: 1,
                                          params: {code: this.code}
                                        })
                                    );
                                    this.store.dispatch(
                                        new ProfileAction.GetAudit({id: this.id, params: {code: this.code}})
                                    );
                                }, 5000);
                            } else {
                                this.navigateToAudit();
                                clearTimeout(this.timeout);

                            }
                        }
                        if (profile.audit.status === 1) {
                            if (profile.audit.bio.progress === undefined || profile.audit.bio.progress === 0 || profile.followerEngage.post_count === 0) {
                                clearTimeout(this.timeout);
                                this.timeout = setTimeout(() => {
                                    this.store.dispatch(
                                        new ProfileAction.GetAudit({id: this.id, params: {code: this.code}})
                                    );
                                    this.store.dispatch(
                                        new ProfileAction.GetFollowerEngage({
                                          id: this.id,
                                          type: 1,
                                          params: {code: this.code}
                                        })
                                    );
                                }, 20000);
                            } else {
                                this.navigateToAudit();
                                clearTimeout(this.timeout);

                            }

                        }

                        if (profile.audit.status === 2) {
                            this.navigateToAudit();
                            clearTimeout(this.timeout);
                        }
                    }


                }
              }
          );
        }
    );

    this.profileState = this.store.select('profile');
  }

  hideInfo() {
    this.infoVisibility = 0;
  }

  navigateToAudit() {
    if (this.code === undefined) {
      this.router.navigate(['audit', this.id]);
    } else {
      this.router.navigate(['audit', this.id, 'code', this.code]);
    }
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
    clearTimeout(this.timeout);
  }

}
